<template>
  <div class="flex w-full">
    <div class="mx-auto text-center">
      <div class="ml-[47%]">
        <LayoutPanelLeft class="w-12 h-12" />
      </div>
      <div class="mt-4 text-2xl dark:text-white">
        {{ $t("Welcome to your") }} <span class="capitalize"> {{ pageName }}</span> {{ $t("Page") }}
      </div>
      <div class="mt-2 text-common-grey">
        {{ !editing_disabled ? $t("Customize your page by clicking on the Add New Component button") : $t("Page has no components added") }}
      </div>
      <button
        v-if="!editing_disabled"
        class="w-48 mt-4 btn primary-btn"
        @click="
          $emitter.emit('addNewComponent', {
            page_reference: pageReference,
            current_template: currentTemplate
          })
        ">
        <span class="mr-3"><ModuleIcon color="white" /></span>{{ $t("Add New component") }}
      </button>
    </div>
  </div>
</template>

<script>
import { LayoutPanelLeft } from "lucide-vue-next"
import ModuleIcon from "@/components/shared/icons/ModuleIcon.vue"
export default {
  components: {
    LayoutPanelLeft,
    ModuleIcon
  },
  inject: ["canUserEditLayout"],
  props: {
    pageReference: {
      type: String,
      required: true
    },
    pageName: {
      type: String,
      required: true
    },
    currentTemplate: {
      type: Object,
      required: true
    }
  },

  emits: [],
  data() {
    return {}
  },
  computed: {
    editing_disabled() {
      let editing_disabled_calc = false
      if (this.$route.name == "WorkspaceItem" && this.$store.state.ui.workspace_user_access_scope == "read") {
        editing_disabled_calc = true
      }

      if (this.$route.name == "Dashboard" && this.$route.params.page) {
        const current_template = this.$store.state.portfolio.shared_layouts.find((l) => l.id == this.$route.params.page)
        if (!this.canUserEditLayout(this.$store.state.auth.user, current_template)) {
          editing_disabled_calc = true
        }
      }

      return editing_disabled_calc
    }
  },

  watch: {},

  created() {},

  methods: {}
}
</script>
